<template>
  <div class="min-h-screen p-4 md:p-6 pb-24 md:pb-6 font-sans text-white">
    <div class="max-w-7xl mx-auto space-y-6">

      <div class="rounded-3xl bg-gradient-to-br from-[#1a2220] via-[#151b1e] to-[#0f1214] border border-[#334D44]/50 shadow-2xl p-6 relative overflow-hidden">
        <div class="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-emerald-500 via-emerald-400 to-transparent opacity-50"></div>
        
        <div class="flex flex-col md:flex-row md:items-end justify-between gap-6 relative z-10">
          <div>
            <h1 class="text-2xl md:text-3xl font-extrabold tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-white to-white/60">
              تاریخچه سفارشات
            </h1>
            <p class="mt-2 text-sm text-white/50">
              مدیریت و پیگیری وضعیت تمامی تراکنش‌های طلا و کیف پول
            </p>
          </div>

          <div class="flex gap-3 overflow-x-auto pb-1 md:pb-0 no-scrollbar">
            <div class="min-w-[100px] px-4 py-2 rounded-2xl bg-white/5 ring-1 ring-white/10 flex flex-col justify-center">
              <span class="text-[10px] text-white/40">تعداد کل</span>
              <span class="text-lg font-bold text-white">{{ nfmt(filteredOrders.length) }}</span>
            </div>
            <div class="min-w-[100px] px-4 py-2 rounded-2xl bg-emerald-500/5 ring-1 ring-emerald-500/20 flex flex-col justify-center">
              <span class="text-[10px] text-emerald-400/60">موفق</span>
              <span class="text-lg font-bold text-emerald-400">{{ nfmt(successCount) }}</span>
            </div>
            <div class="min-w-[100px] px-4 py-2 rounded-2xl bg-amber-500/5 ring-1 ring-amber-500/20 flex flex-col justify-center">
              <span class="text-[10px] text-amber-400/60">در انتظار</span>
              <span class="text-lg font-bold text-amber-400">{{ nfmt(pendingCount) }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col lg:flex-row gap-4 items-center justify-between">
        
        <div class="w-full lg:w-auto p-1 bg-[#151b1e] rounded-2xl border border-white/5 flex">
          <button 
            v-for="tab in tabs" :key="tab.id"
            @click="activeTab = tab.id"
            class="flex-1 lg:flex-none px-6 py-2.5 rounded-xl text-sm font-bold transition-all duration-300"
            :class="activeTab === tab.id ? 'bg-[#b9f1cf] text-[#0a1f14] shadow-lg shadow-emerald-900/20' : 'text-white/50 hover:text-white hover:bg-white/5'"
          >
            {{ tab.label }}
          </button>
        </div>

        <div class="w-full lg:w-auto flex gap-3">
          <div class="relative w-full lg:w-72 group">
            <input 
              v-model="searchQuery"
              type="text" 
              placeholder="جستجو در تراکنش‌ها..." 
              class="w-full bg-[#151b1e] border border-white/10 rounded-2xl px-10 py-3 text-sm text-white placeholder-white/30 focus:outline-none focus:border-emerald-500/50 focus:ring-1 focus:ring-emerald-500/50 transition-all"
            >
            <i class="fas fa-search absolute right-3.5 top-1/2 -translate-y-1/2 text-white/30 group-focus-within:text-emerald-400 transition-colors"></i>
            <button v-if="searchQuery" @click="searchQuery = ''" class="absolute left-3 top-1/2 -translate-y-1/2 text-white/30 hover:text-rose-400">✕</button>
          </div>
          
          <select v-model="itemsPerPage" class="bg-[#151b1e] border border-white/10 rounded-2xl px-3 py-2 text-sm text-white/70 focus:outline-none focus:border-emerald-500/50">
            <option :value="10">۱۰</option>
            <option :value="20">۲۰</option>
            <option :value="50">۵۰</option>
          </select>
        </div>
      </div>

      <div class="rounded-3xl bg-[#151b1e] border border-white/5 overflow-hidden min-h-[400px] relative">
        
        <div v-if="loading" class="absolute inset-0 flex items-center justify-center bg-[#151b1e]/80 z-20 backdrop-blur-sm">
          <div class="flex flex-col items-center gap-3">
            <div class="w-8 h-8 border-2 border-emerald-400 border-t-transparent rounded-full animate-spin"></div>
            <span class="text-xs text-emerald-400 animate-pulse">در حال دریافت اطلاعات...</span>
          </div>
        </div>

        <div v-else-if="filteredOrders.length === 0" class="flex flex-col items-center justify-center py-20 opacity-50">
          <i class="fas fa-box-open text-4xl mb-4 text-white/20"></i>
          <p class="text-sm">سفارشی یافت نشد</p>
        </div>

        <template v-else>
          <div class="hidden md:block overflow-x-auto">
            <table class="w-full text-right border-collapse">
              <thead>
                <tr class="text-xs text-white/40 border-b border-white/5 bg-white/[0.02]">
                  <th class="p-4 font-medium">#</th>
                  <th class="p-4 font-medium">نوع تراکنش</th>
                  <th class="p-4 font-medium">جزئیات (وزن / مبلغ)</th>
                  <th class="p-4 font-medium">مبلغ کل</th>
                  <th class="p-4 font-medium">وضعیت</th>
                  <th class="p-4 font-medium">تاریخ و ساعت</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-white/5">
                <tr v-for="(item) in paginatedData" :key="item._id" class="group hover:bg-white/[0.02] transition-colors">
                  
                  <td class="p-4 text-sm text-white/30 font-mono">{{item.uid }}</td>
                  
                  <td class="p-4">
                    <div class="flex items-center gap-2">
                      <div class="w-8 h-8 rounded-full flex items-center justify-center text-xs"
                           :class="getTypeConfig(item).bg">
                         <i :class="['fas', getTypeConfig(item).icon]"></i>
                      </div>
                      <div>
                        <div class="text-sm font-bold text-white/90">{{ getTypeConfig(item).label }}</div>
                        <div class="text-[10px] text-white/40">{{ item.key || item.item || '---' }}</div>
                      </div>
                    </div>
                  </td>

                  <td class="p-4">
                     <div v-if="activeTab === 'gold'" class="flex items-center gap-1">
                        <span class="text-white font-bold">{{ item.weight }}</span>
                        <span class="text-[10px] text-white/50">گرم</span>
                     </div>
                     <div v-else class="flex items-center gap-1">
                        <span class="text-white font-bold">{{ nfmt(item.amount) }}</span>
                        <span class="text-[10px] text-white/50">تومان/عدد</span>
                     </div>
                  </td>

                  <td class="p-4">
                    <div class="flex items-center gap-1">
                      <span class="text-sm font-bold tracking-tight" 
                            :class="item.typeorder === 'buy' || item.type === 'buy' ? 'text-emerald-400' : 'text-white'">
                        {{ nfmt(item.price || item.totalPrice || item.amount * item.unitPrice || 0) }}
                      </span>
                      <span class="text-[10px] text-white/40">تومان</span>
                    </div>
                  </td>

                  <td class="p-4">
                    <span class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-medium border"
                          :class="getStatusConfig(item).class">
                      <i class="fas text-[10px]" :class="getStatusConfig(item).icon"></i>
                      {{ getStatusConfig(item).text }}
                    </span>
                    <div v-if="item.rejectReason" class="text-[10px] text-rose-400 mt-1 mr-1 max-w-[150px] truncate">
                       دلیل: {{ item.rejectReason }}
                    </div>
                  </td>

                  <td class="p-4 text-xs text-white/50 dir-ltr font-mono text-right">
                    {{ toPersianDate(item.createdAt) }}
                  </td>

                </tr>
              </tbody>
            </table>
          </div>

          <div class="md:hidden p-3 space-y-3">
            <div v-for="(item, idx) in paginatedData" :key="item._id" 
                 class="bg-[#1a2220] border border-white/5 rounded-2xl p-4 relative overflow-hidden">
              
              <div class="absolute left-0 top-0 bottom-0 w-1" :class="getStatusConfig(item).barColor"></div>

              <div class="flex justify-between items-start mb-3">
                 <div class="flex items-center gap-2">
                    <div class="w-8 h-8 rounded-full flex items-center justify-center text-xs"
                         :class="getTypeConfig(item).bg">
                       <i :class="['fas', getTypeConfig(item).icon]"></i>
                    </div>
                    <div>
                      <div class="text-sm font-bold text-white">{{ getTypeConfig(item).label }}</div>
                      <div class="text-[10px] text-white/40">{{ item.key || item.item || '---' }}</div>
                    </div>
                 </div>
                 <span class="text-[10px] text-white/30 font-mono">{{ toPersianDate(item.createdAt) }}</span>
              </div>

              <div class="grid grid-cols-2 gap-3 text-xs mb-3">
                <div class="bg-white/5 rounded-xl p-2">
                  <span class="block text-white/40 mb-1">مقدار / وزن</span>
                  <span class="font-bold text-white">{{ activeTab==='gold' ? item.weight + ' گرم' : nfmt(item.amount) }}</span>
                </div>
                <div class="bg-white/5 rounded-xl p-2">
                  <span class="block text-white/40 mb-1">مبلغ کل</span>
                  <span class="font-bold" :class="item.typeorder === 'buy' || item.type === 'buy' ? 'text-emerald-400' : 'text-white'">
                    {{ nfmt(item.price || item.totalPrice || item.amount * item.unitPrice || 0) }}
                  </span>
                </div>
              </div>

              <div class="flex items-center justify-between pt-3 border-t border-white/5">
                 <span class="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md text-xs border"
                       :class="getStatusConfig(item).class">
                   {{ getStatusConfig(item).text }}
                 </span>
                 <span class="text-[10px] text-white/20">#{{ getRowIndex(idx) }}</span>
              </div>
              
              <div v-if="item.rejectReason" class="mt-2 text-[10px] text-rose-300 bg-rose-500/10 p-2 rounded-lg">
                <i class="fas fa-info-circle ml-1"></i>
                علت رد: {{ item.rejectReason }}
              </div>

            </div>
          </div>
        </template>

        <div v-if="totalPages > 1" class="border-t border-white/5 p-4 flex flex-col md:flex-row items-center justify-between gap-4">
           <span class="text-xs text-white/40 order-2 md:order-1">
             نمایش {{ getRowIndex(0) }} تا {{ getRowIndex(paginatedData.length - 1) }} از {{ filteredOrders.length }}
           </span>
           <div class="flex items-center gap-2 order-1 md:order-2">
             <button @click="currentPage--" :disabled="currentPage === 1" class="w-8 h-8 rounded-lg bg-white/5 hover:bg-white/10 flex items-center justify-center disabled:opacity-30 transition">‹</button>
             <span class="text-sm font-bold text-emerald-400">{{ currentPage }}</span>
             <span class="text-xs text-white/30">/ {{ totalPages }}</span>
             <button @click="currentPage++" :disabled="currentPage === totalPages" class="w-8 h-8 rounded-lg bg-white/5 hover:bg-white/10 flex items-center justify-center disabled:opacity-30 transition">›</button>
           </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import axios from 'axios'

const API = process.env.VUE_APP_API_URL

const loading = ref(true)
const goldOrders = ref([])
const walletOrders = ref([])
const activeTab = ref('gold')
const searchQuery = ref('')
const currentPage = ref(1)
const itemsPerPage = ref(10)

const tabs = [
  { id: 'gold', label: 'سفارشات طلا' },
  { id: 'wallet', label: 'تراکنش‌های کیف پول' }
]

onMounted(async () => {
  try {
    const [resGold, resWallet] = await Promise.all([
      axios.get(`${API}/user/wallet/order`),
      axios.get(`${API}/user/order`)
    ])
    
    goldOrders.value = resGold.data?.data || []
    walletOrders.value = resWallet.data?.data || []
    
  } catch (error) {
    console.error(error)
  } finally {
    loading.value = false
  }
})

const nfmt = (n) => new Intl.NumberFormat('fa-IR').format(Number(n) || 0)
const toPersianDate = (date) => {
  if(!date) return '---'
  return new Date(date).toLocaleString('fa-IR', {
     year: 'numeric', month: '2-digit', day: '2-digit', 
     hour: '2-digit', minute: '2-digit'
  })
}

const getTypeConfig = (item) => {
  if (item.typeorder) {
     return item.typeorder === 'buy' 
       ? { label: 'خرید طلا', icon: 'fa-arrow-down', bg: 'bg-emerald-500/10 text-emerald-400' }
       : { label: 'فروش طلا', icon: 'fa-arrow-up', bg: 'bg-rose-500/10 text-rose-400' }
  }
  
  if (item.type) {
     const t = item.type.toLowerCase()
     if(t === 'buy') return { label: 'خرید ', icon: 'fa-shopping-bag', bg: 'bg-emerald-500/10 text-emerald-400' }
     if(t === 'sell') return { label: 'فروش ', icon: 'fa-coins', bg: 'bg-rose-500/10 text-rose-400' }
     if(t === 'deposit') return { label: 'افزایش موجودی', icon: 'fa-plus', bg: 'bg-blue-500/10 text-blue-400' }
     if(t === 'withdraw') return { label: 'درخواست تسویه', icon: 'fa-minus', bg: 'bg-amber-500/10 text-amber-400' }
  }
  
  return { label: 'نامشخص', icon: 'fa-circle', bg: 'bg-gray-500/10 text-gray-400' }
}

const getStatusConfig = (item) => {
   let s = 'pending'
   if(item.status) s = item.status.toLowerCase()
   else if(item.isApproved === true) s = 'approved'
   else if(item.isApproved === false && item.rejectReason) s = 'rejected'

   switch(s) {
      case 'approved':
      case 'success':
         return { 
           text: 'تایید شده', 
           class: 'bg-emerald-500/5 text-emerald-400 border-emerald-500/20', 
           icon: 'fa-check',
           barColor: 'bg-emerald-500' 
         }
      case 'rejected':
      case 'failed':
         return { 
           text: 'رد شده', 
           class: 'bg-rose-500/5 text-rose-400 border-rose-500/20', 
           icon: 'fa-times',
           barColor: 'bg-rose-500'
         }
      case 'pending':
      default:
         return { 
           text: 'در انتظار بررسی', 
           class: 'bg-amber-500/5 text-amber-400 border-amber-500/20', 
           icon: 'fa-clock',
           barColor: 'bg-amber-500'
         }
   }
}

const currentList = computed(() => activeTab.value === 'gold' ? goldOrders.value : walletOrders.value)

const filteredOrders = computed(() => {
  let list = currentList.value
  if(searchQuery.value) {
    const q = searchQuery.value.toLowerCase()
    list = list.filter(i => 
       (i.typeorder && i.typeorder.includes(q)) || 
       (i.type && i.type.includes(q)) ||
       (i.amount && i.amount.toString().includes(q)) ||
       (i.price && i.price.toString().includes(q))
    )
  }
  return list
})

const totalPages = computed(() => Math.ceil(filteredOrders.value.length / itemsPerPage.value))

const paginatedData = computed(() => {
   const start = (currentPage.value - 1) * itemsPerPage.value
   return filteredOrders.value.slice(start, start + itemsPerPage.value)
})

const successCount = computed(() => currentList.value.filter(i => i.isApproved === true || i.status === 'approved').length)
const pendingCount = computed(() => currentList.value.filter(i => !i.isApproved && i.status !== 'rejected').length)

const getRowIndex = (idx) => (currentPage.value - 1) * itemsPerPage.value + idx + 1

watch([activeTab, searchQuery], () => currentPage.value = 1)
</script>

<style scoped>
.no-scrollbar::-webkit-scrollbar { display: none; }
.no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
</style>